/**
 * Programmatically inject the Microsoft Clarity tracking script.
 * @param {string} projectId – Your Clarity Project ID (e.g. "abcdef1234")
 */
export function initClarity(projectId) {
  if (!projectId) {
    console.warn('[Clarity] No project ID provided — skipping initialization.');
    return;
  }

  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", projectId);

  console.log('[Clarity] Tracking initialized with project:', projectId);
}
